module.exports = __webpack_public_path__ + "img/1fe4f7c.jpg";